module.exports = __webpack_public_path__ + "static/app/img/case_bg.f2bf4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/case_bg.jpg
// module id = e2Fo
// module chunks = 1